import styled from 'styled-components';
import { body2Bold, H2, Caption, colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { DeltaType, DELTA_TYPE_TO_COLOR_MAP } from './MetricsDetails.utils';

export const StyledTooltip = styled(Tooltip)`
  color: ${colors.secondaryText};
  display: inline-block;
  margin-bottom: ${spacing.quarter};
`;

export const GoalInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const Value = styled(H2)`
  margin: 0;
  line-height: 1;
`;

export const Delta = styled.span`
  ${body2Bold}
  display: inline-flex;
  align-items: center;
  margin: 0;

  &[data-delta-type=${DeltaType.Positive}] {
    color: ${DELTA_TYPE_TO_COLOR_MAP[DeltaType.Positive].textColor};
  }

  &[data-delta-type=${DeltaType.Negative}] {
    color: ${DELTA_TYPE_TO_COLOR_MAP[DeltaType.Negative].textColor};
  }

  &[data-delta-type=${DeltaType.Neutral}] {
    color: ${DELTA_TYPE_TO_COLOR_MAP[DeltaType.Neutral].textColor};
  }
`;

export const StyledCaption = styled(Caption)`
  color: ${colors.textDisabled};
`;
